// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeUserManagement_main__MFD06 {
    width: 100%;
    height: 100%;
}

.CategorizeUserManagement_header__U\\+ICo {
    display: flex;
    justify-content: space-between;
    height: 35px;
    margin-bottom: 25px;
}

.CategorizeUserManagement_title__tcp\\+J {
    font-size: 30px;
}

.CategorizeUserManagement_container__2ndaH {
    width: 100%;
    height: calc(100% - 60px);
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.CategorizeUserManagement_container_header__uTQRr {
    width: 100%;
    height: 100px;
    font-size: 24px;
}

.CategorizeUserManagement_container_main__enkfK {
    width: 100%;
    height: calc(100% - 100px);
}

.CategorizeUserManagement_container_main_show__PPOSI {
    width: 50%;
    height: calc(50% - 100px);
}

.CategorizeUserManagement_container_null__IBwhK {
    padding: 20px;
    font-size: 20px;
    text-align: center;
}

.CategorizeUserManagement_item_box__1EziC {
    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeUserManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    height: calc(100% - 60px);\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.container_header {\n    width: 100%;\n    height: 100px;\n    font-size: 24px;\n}\n\n.container_main {\n    width: 100%;\n    height: calc(100% - 100px);\n}\n\n.container_main_show {\n    width: 50%;\n    height: calc(50% - 100px);\n}\n\n.container_null {\n    padding: 20px;\n    font-size: 20px;\n    text-align: center;\n}\n\n.item_box {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CategorizeUserManagement_main__MFD06`,
	"header": `CategorizeUserManagement_header__U+ICo`,
	"title": `CategorizeUserManagement_title__tcp+J`,
	"container": `CategorizeUserManagement_container__2ndaH`,
	"container_header": `CategorizeUserManagement_container_header__uTQRr`,
	"container_main": `CategorizeUserManagement_container_main__enkfK`,
	"container_main_show": `CategorizeUserManagement_container_main_show__PPOSI`,
	"container_null": `CategorizeUserManagement_container_null__IBwhK`,
	"item_box": `CategorizeUserManagement_item_box__1EziC`
};
export default ___CSS_LOADER_EXPORT___;
